import { render } from "./DonationType.vue?vue&type=template&id=aa8aecd6"
import script from "./DonationType.vue?vue&type=script&lang=js"
export * from "./DonationType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__